import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, merge, map, findIndex } from 'lodash';
import { withRouter } from 'react-router';
import SimpleFileInput from '../../../../common/components/c_SourceSimpleFileInput';
import FlatButton from '../../../../common/components/c_FlatButton';
import ProgressComponentList from '../../../../common/components/C_ProgressComponentList';
import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

import shortId from 'shortid';

import * as jobRequestDocumentsApi from '../../../../redux/actionCreators/async/jobrequestDocuments';
import * as jobRequestDocumentsStore from '../../../../redux/actionCreators/sync/jobrequestDocuments';

import SubmissionBar from '../../SubmissionBar';
import DocumentItemView from '../DocumentItemView';

const addButtonStyle = {
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};

@connect((store, props) => {
	return {
		user: store.user,
		documents: store.jobRequestDocuments.documents,
		jobId: parseInt(props.params.jobId || 0, 10),
	};
})
class AddDocuments extends ProgressComponentList {

	static propTypes = {
		user: PropTypes.object,
		checkComplete: PropTypes.func,
		tempState: PropTypes.object,
		documents: PropTypes.array.isRequired,
		dispatch : PropTypes.func.isRequired
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			profileId: this.props.user.profileId,
			isDirty: false,
			documents:  null,
			documentsModel: this.cloneCollection(props.documents),
			showTransitionBlocker: false,
			transitionRoute: '',
			stateSaved: true,
		};

		this.onRemoveDocument = :: this.onRemoveDocument;
		this.onChangeDocument = :: this.onChangeDocument;
		this.onUploadStart =  ::this.onUploadStart;

	}

	cloneCollection(collection){
		return  _.chain(collection).map( (item) => merge({}, item) ).value()
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.documents){
			const documentsModel = get(nextProps, 'documents',[]);
      		this.setState(merge({}, {documentsModel} ));
    	}
	}

	componentDidMount() {

		this.props.router.setRouteLeaveHook(this.props.route, (location) => {

			const jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;

			if ( jobRequestSteps.test(location.pathname) ){
				this.state.primaryButtonLabel = 'Stay';
				this.state.secondaryButtonLabel = 'Leave';

			}else{
				this.state.primaryButtonLabel = undefined;
				this.state.secondaryButtonLabel = undefined;
			}

			if (!this.state.stateSaved ){
				this.setState(merge({}, this.state, {showTransitionBlocker: true,  transitionRoute: location.pathname}));
				return this.state.stateSaved;
			}else{
				return true;
			}

		});
	}


	handleSave = (event, cb) => {

		let documents = _
			.chain(this.state.documentsModel)
				.map( (newDocument) =>  this.saveNewDocument(newDocument) ) // Save new documents.
				.map( (document)    =>  this.updateDocument(document) ) 	// Update created documents.
				.filter( (document) =>  this.removeDocument(document) ) 	// Delete  created documents.

		this.setState({isDirty: true, stateSaved: true}, () => {
			this.props.dispatch(jobRequestDocumentsStore.updateJobRequestDocuments(documents.value()));
			cb();
		});

	}

	saveNewDocument = (document) => {

		if(document.isNew === true  && document.softDelete !== true){
			const processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete' ]);
			this.props.dispatch(jobRequestDocumentsApi.createJobRequestDocuments(this.props.user.profileId, processedDoc));
			return processedDoc;
		}else{
			return document;
		}
	}

	updateDocument = (document) => {

		if(document.isModified === true && document.softDelete !== true ){
			const processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete', 'fileTypeId' ]);
			this.props.dispatch(jobRequestDocumentsApi.updateJobRequestDocuments(this.props.user.profileId, processedDoc));
			return processedDoc;
		}else{
			return document;
		}

	}

	removeDocument = (document) => {

		// We filter out this document. check handleSave function.

		if(document.softDelete === true && document.isNew !== true ){
			const processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete', 'fileTypeId' ]);
			this.props.dispatch(jobRequestDocumentsApi.deleteJobRequestDocuments(this.props.user.profileId, processedDoc));
			return false;
		}else{
			return true;
		}

	}

	handleSaveAndNext = (event) => {

		this.handleSave(event, () => {
			this.props.checkComplete();
			this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/skills`));

		});

	}

	handleBack = (event) => {
		this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/description`));
	}

	onUploadStart = (err, infoObj) => {
    const clientId = `${this.getIncrementedChar()}${shortId.generate()}`;

	this.state.documentsModel.push({
		jobId: this.props.params.jobId,
		clientId: clientId,
		fileName: infoObj.name,
		fileSize:  infoObj.size,
		storagePath: infoObj.nameWithFolder,
		fileTypeId: infoObj.type,
		isNew: true,
		isModified: false,
	});

	this.state.stateSaved  = false;

	this.setState(merge({}, this.state));

  }

  onS3Load = err => {
    // updating UI optimistically so we only need to know if there was an error
    if(err && process.env.NODE_ENV !== 'production') {
      console.error(err);
    }
  }

  onRemoveDocument(document){

 	let index = findIndex(this.state.documentsModel,document);

	if(index === -1) return;

	this.state.documentsModel[index].softDelete = true;
	this.state.stateSaved  = false;
	this.setState(merge({}, this.state));

  }

  onChangeDocument(description, document){

	  let index = findIndex(this.state.documentsModel,{clientId: document.clientId});

	  if(index === -1) return;

	  this.state.documentsModel[index].description = description;

	  // We only mark as modified if the document is stored in DB.
	  if(this.state.documentsModel[index].isNew !== true) {
		   this.state.documentsModel[index].isModified = true;
	  }

	  this.state.stateSaved  = false;

	  this.setState(merge({}, this.state));
  }

	closeTransitionBlocker = () => {
		this.setState(merge({}, this.state, {showTransitionBlocker: false}));
	}

	transitionFunction = () => {
		this.setState({stateSaved: true}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}

	render() {

		let {documentsModel} = this.state || [];

		return (
			<div className='add-documents'>

				{
					this.state.showTransitionBlocker
					&&
					<RouteTransitionBlocker
            cancelAction={this.closeTransitionBlocker.bind(this)}
            primaryAction={this.closeTransitionBlocker.bind(this)}
            primaryButtonLabel={this.state.primaryButtonLabel}
            secondaryButtonLabel={this.state.secondaryButtonLabel}
						secondaryAction={this.transitionFunction.bind(this)}
						transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
					/>
				}

				<h1>Add Documents </h1>
				<h2>Please provide us with any documents needed. </h2>
				<div className='documents-container'>
					<SimpleFileInput
					className='file-uploader'
					noMessage
					pristineClass=''
					loadingClass=''
					successClass=''
					failureClass=''
					accept={['pdf', 'doc', 'docx','xls','xlsx', 'tiff','tig', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png']}
					remoteFolder={`contacts/${this.state.profileId}`}
					onLoadStart={this.onUploadStart}
					onS3Load={this.onS3Load}
					signingRoute='/api/s3/put-sign'
					maxSize={process.env.AWS_FILE_UPLOAD_SIZE}
					>
					<FlatButton
						style={addButtonStyle}
						label='Attach File'
					/>
					</SimpleFileInput>
				</div>

				{
					map(documentsModel, (document) => document.softDelete === true  ?  null : <DocumentItemView data-id={`document-item=-${document.id}`} key={document.id} data={document} onChange={this.onChangeDocument} onRemove={this.onRemoveDocument} />)
				}

				<SubmissionBar
					onBack={this.handleBack}
					onNext={this.handleSaveAndNext}
					onSave={this.handleSave}
				/>

			</div>
		);
	}
}
export default withRouter(AddDocuments);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/AddDocuments/index.js